
import { $AjaxJson } from '@/lf'
import { $Urlpath, $UrlApipath } from '@/config/config'
export const CompanyInfoRequest = {

    GetCompanyInfo(func, ID) {
        $AjaxJson($UrlApipath + "System/GetCompanyInfo", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddCompanyInfo(func, obj) {
        $AjaxJson($UrlApipath + "System/AddCompanyInfo", obj, function (d) {
            func(d)
        })
    },
    UpdateCompanyInfo(func, obj) {
        $AjaxJson($UrlApipath + "System/UpdateCompanyInfo", obj, function (d) {
            func(d)
        })
    },
    SearchCompanyInfo(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchCompanyInfo", obj, function (d) {
            func(d)
        })
    },
    SearchCompanyInfoList(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchCompanyInfoList", obj, function (d) {
            func(d)
        })
    },
    
    SetCompanyInfoStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "System/SetCompanyInfoStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },
}



// WEBPACK FOOTER //
// ./src/request/CompanyInfo.js